<template>
  <div class="px-4">
    <div class="search-box chat-search-box">
      <div class="input-group mb-3 bg-light input-group-lg rounded-lg">
        <div class="input-group-prepend">
          <button
            class="btn btn-link text-muted pr-1 text-decoration-none"
            type="button"
          >
            <i class="ri-search-line search-icon font-size-18" />
          </button>
        </div>
        <input
          v-model="search"
          type="search"
          class="form-control bg-light"
          :placeholder="$t('tabs.chats.search.placeholder')"
        >
        <!--room-create /-->
      </div>
    </div>
  </div>
</template>

<script>
// import RoomCreate from "./CreateSearchRoomsComponents";

import debounce from "lodash.debounce";

export default {
  name: 'RoomsSearch',
  components: {
    // RoomCreate,
  },
  data() {
    return {
      search: '',
    }
  },
  watch: {
    search(val) {
      this.searchDebounce(val)
    },
  },
  methods: {
    searchDebounce: debounce(function (val) {
      this.$store.commit('rooms/SET_FILTER_QUERY', val)
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.VueCarousel-slide > div {
  padding-left: 5px;
  padding-right: 5px;
}
</style>






